import { render, staticRenderFns } from "./AnagraficheDettaglioTipologie.vue?vue&type=template&id=648b37e9&scoped=true&"
import script from "./AnagraficheDettaglioTipologie.vue?vue&type=script&lang=js&"
export * from "./AnagraficheDettaglioTipologie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648b37e9",
  null
  
)

export default component.exports